<template>
  <div>
    <!-- back to top button -->
    <back-to-top :itemScale="bttSize"></back-to-top>
    <!-- header -->
    <header class="site-header" :class="{'scrolled': scrollPos > 0}" role="banner">
      <div class="site-top">
        <span class="site-title">
          <slot name="title">
            <img src="@/assets/img/logo.svg" alt="Site Logo" class="logo" style="height:40px;margin-bottom:15px;" />
            <a :href="siteURL">
              <!-- {{ siteTitle }} -->
              T2T-Hub
            </a>
          </slot>
        </span>
        <div class="navbar">				
          <nav>
            <slot name="navlist">
              <ul>
                <li v-for="(item, index) in siteNav" :key="index">
                  <router-link :to="item.route"
                  :class="{'active': activeState[index]}">
                    {{ item.label }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </nav><!-- #site-navigation -->
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import BackToTop from './BackToTop.vue';


function getScrollTop() {
   var scrollPos;
   if (window.scrollY)
   {
       scrollPos = window.scrollY;
   }
   else if (document.compatMode && document.compatMode != 'BackCompat')
   {
       scrollPos = document.documentElement.scrollTop;
   }
   else if (document.body)
   {
       scrollPos = document.body.scrollTop;
   }
   return scrollPos;
}



export default {
  components: { BackToTop },
  props: {
    siteTitle: {
      type: String,
      default: 'XXX Database'
    },
    siteURL: {
      type: String,
      default: '#'
    },
    siteNav: {
      type: Array,
      default: () => [
        {route: '/home', label: 'Home'},
        {route: '/help', label: 'Help'}
      ]
    },
    activeState: {
      type: Array,
    }
  },
  data() {
    return {
      scrollPos: 0,
      bttSize: 0,
    }
  },
  mounted() {
    window.onscroll = () => {
      let scrollValue = getScrollTop()
      this.scrollPos = scrollValue
      if(scrollValue > 30) {
        this.bttSize = 1
      }else{
        this.bttSize = 0
      }
    }
  },
}
</script>

<style>
  /* style of header */
  .site-header {
    text-shadow: 0 0 1px rgba(0, 0, 0, .1);
    line-height: 1.5;
    font-family: 'Noto Serif SC', 'Source Han Serif SC', 'Source Han Serif', source-han-serif-sc, 'PT Serif', 'SongTi SC', 'MicroSoft Yahei', Georgia, serif;
    font-size: 15px;
    box-sizing: border-box;
    display: block;
    transition: all 1s ease !important;
    word-break: keep-all;
    user-select: none;
    width: 100%;
    height: 75px;
    top: 0;
    left: 0;
    background: 0 0;
    position: fixed;
    z-index: 999;
    border-radius: 0px;
  }
  .site-header.scrolled {
    background-color: rgba(180,180,180,0.7);
  }
  .site-header:hover {
    background-color: rgba(180,180,180,0.7);
  }

  .site-top {
    display: block;
    margin: 0 auto;
    padding: 0 20px;
  }

  /* style of title */

  .site-title {
    animation: sitetop 1s;
    float: left;
    position: relative;
    height: 75px;
    line-height: 75px;
    margin-left: -6px;
  }

  .site-title a {
    color: #505050;
    font-size: 25px;
    font-weight: 800;
    height: 56px;
    line-height: 56px;
    padding-right: 8px;
    padding-top: 8px;
    text-decoration-line: none;
    transition: all .5s ease !important;
  }

  .site-title a:hover {
    color: #2ca25f
  }

  /* style of navbar */

  .navbar {
    animation: searchbox 1s;
    position: relative;
    float: right;
    margin: 15px 0 0 0;
    font-size: 16px;
  }

  .navbar ul {
    list-style: none;
  }

  .navbar ul li {
    float: left;
    margin-left: 28px;
    position: relative;
    transition: all 1s ease;
  }

  .navbar ul li a {
    color: #505050;
    font-weight: 600;
    text-decoration-line: none;
    padding: 10px 0;
    transition: all .25s ease;
  }

  .navbar ul li a.active {
    color: #2ca25f;
  }

  .navbar ul li a::after {
    content: "";
    display: block;
    position: absolute;
    bottom: -16px;
    height: 6px;
    background-color: #2ca25f;
    width: 100%;
    max-width: 0;
    transition: max-width .25s ease-in-out;
  }

  .navbar ul li a:hover::after {
    max-width: 100%;
  }

  /* definition of keyframe */

  @keyframes sitetop {
    0% {
      opacity: 0;
      transform: translateX(-30px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    } 
  }
</style>

